/**
 * Created by Christof Sander on 01.07.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	methods: {
		onSubmit: function(response){
			var data = this.resourceData.data || {};
			var segmentID = ((response.data || {}).attributes || {}).segmentID || (data.attributes || {})[data.primaryKey || 'id'];
			this.closest('templates_newsletter_segments_controller', function(controller){
				controller.find('templates_newsletter_segments_list', function(list){
					list.refreshSegmentCount(segmentID)
				})
			})
			this.destroy();
		}
	}
};
